// src/services/paths/telephonyPaths.js
// Centralized builders for telephony-related Firestore paths.

import { assertTelephonyPathNormalized } from '../guards/telephonyDriftGuard';

export const telephonyProfileDocPath = (businessId) => {
  if (!businessId) {
    throw new Error('telephonyProfileDocPath requires a businessId');
  }

  const path = `businesses/${businessId}/telephonyProfile/profile`;
  assertTelephonyPathNormalized(path, businessId);
  return path;
};
